// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIsAfterPayEnabled,
  getAfterPayMinAmount,
  getAfterPayMinOrderAmount,
  getAfterPayMaxOrderAmount,
  getExtendedPreOrderValue,
  getIsCashAppAfterpayLogoEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import selectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import BagPageSelectors from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { getAfterpayIneligibleStates } from './AfterPayMessaging.selectors';
import AfterPayMessaging from '../views';

export class AfterPayMessagingContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { offerPrice, isPayPalWebViewEnable, preOrderDate } = this.props;
    return (
      nextProps.offerPrice !== offerPrice ||
      nextProps.isPayPalWebViewEnable !== isPayPalWebViewEnable ||
      nextProps.preOrderDate !== preOrderDate
    );
  }

  getState = () => {
    const tcpStatePromise = readCookie('tcpState');
    if (tcpStatePromise) {
      return tcpStatePromise;
    }
    return null;
  };

  render() {
    return <AfterPayMessaging {...this.props} getUserState={this.getState} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isAfterPayEnabled: getIsAfterPayEnabled(state),
    afterPayMinAmount: getAfterPayMinAmount(state),
    afterPayMinOrderAmount: getAfterPayMinOrderAmount(state),
    afterPayMaxOrderAmount: getAfterPayMaxOrderAmount(state),
    cartHaveGCItem: selectors.getIsCartHaveGiftCards(state),
    afterPayIneligibleStates: getAfterpayIneligibleStates(state),
    isPayPalWebViewEnable: BagPageSelectors.getPayPalWebViewStatus(state),
    extendedOrderThreshold: getExtendedPreOrderValue(state),
    isCashAppAfterpayLogoEnabled: getIsCashAppAfterpayLogoEnabled(state),
  };
};

AfterPayMessagingContainer.propTypes = {
  offerPrice: PropTypes.number.isRequired,
  preOrderDate: PropTypes.string,
};

export default connect(mapStateToProps)(AfterPayMessagingContainer);
